import { ReportState } from '../types/state';
import { AnyAction } from 'redux';
import { ReportActionTypes } from '../actions/reports';
import { AUTH_ACTIONS } from '../actions/auth';

const initialState: ReportState = {
  isLoading: false,
  reportData: undefined,
  prevOfferData: {},
  overrideData: {},
  execDownloadUrl: undefined,
  downloadReady: undefined,
  downloadOverrideReady: undefined,
  leasePriceData: undefined,
};

const reportReducer = (
  state: ReportState = initialState,
  action: AnyAction
) => {
  switch (action.type) {
    case ReportActionTypes.IS_LOADING: {
      return Object.assign({}, state, { isLoading: action.payload });
    }
    case ReportActionTypes.SET_LEASE_PRICE_DATA: {
      return Object.assign({}, state, { leasePriceData: action.payload });
    }
    case ReportActionTypes.AVAILABLE_REPORTS_DATA: {
      return Object.assign({}, state, { reportData: action.payload });
    }
    case ReportActionTypes.GET_OFFER_COMPILANCE: {
      return Object.assign({}, state, { offerCompilance: action.payload });
    }
    case ReportActionTypes.GET_RENEWAL_FORECAST: {
      return Object.assign({}, state, { renewalForecast: action.payload });
    }
    case ReportActionTypes.PREV_OFFER_DATA: {
      const { offer_cycle, data } = action.payload;
      return Object.assign({}, state, {
        prevOfferData: { ...state.prevOfferData, ...data },
        downloadReady: offer_cycle,
      });
    }
    case ReportActionTypes.EXEC_SUMMARY_URL: {
      let { url } = action.payload;
      return Object.assign({}, state, { execDownloadUrl: url });
    }
    case ReportActionTypes.OVERRIDE_REPORT_DATA: {
      let { offer_cycle, data } = action.payload;
      return Object.assign({}, state, {
        overrideData: { [offer_cycle]: data },
        downloadOverrideReady: offer_cycle,
      });
    }
    case ReportActionTypes.DATA_DOWNLOAD_FLAG: {
      return Object.assign({}, state, { downloadReady: action.payload });
    }
    case ReportActionTypes.OVERRIDE_DATA_DOWNLOAD_FLAG: {
      return Object.assign({}, state, {
        downloadOverrideReady: action.payload,
      });
    }
    case AUTH_ACTIONS.LOGOUT: {
      return initialState;
    }
    default:
      return state;
  }
};

export default reportReducer;
